<dx-data-grid id="grid"
              [allowColumnReordering]="true"
              [columnAutoWidth]="true"
              [dataSource]="remoteDataSource"
              [repaintChangesOnly]="true"
              [wordWrapEnabled]="true"
              dateSerializationFormat="yyyy-MM-ddTHH:mm:ss"
              (onInitNewRow)="onInitNewRow($event)"
              (onRowDblClick)="onRowDblClick($event)"
              (onRowPrepared)="onRowPrepared($event)"
              (onSelectionChanged)="selectedChanged($event)"
              keyField="expenseId">
  <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
  <dxo-data-grid-grouping [autoExpandAll]="true"></dxo-data-grid-grouping>
  <dxo-data-grid-group-panel [visible]="isLuce"></dxo-data-grid-group-panel>
  <dxo-data-grid-header-filter [visible]="true">
    <dxo-data-grid-search [enabled]="true"></dxo-data-grid-search>
  </dxo-data-grid-header-filter>
  <dxo-data-grid-editing mode="popup">
    <dxo-data-grid-popup title="Investimenti"
               [showTitle]="true">
    </dxo-data-grid-popup>
    <dxo-data-grid-form>
      <dxi-data-grid-item dataField="dataRichiesta"
                [visible]="false">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="dataInvestimento">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="investmentTypeId"></dxi-data-grid-item>
      <dxi-data-grid-item dataField="note"
                editorType="dxTextArea"
                [colSpan]="2">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="importo"></dxi-data-grid-item>

      <dxi-data-grid-item dataField="paymentTypeId"></dxi-data-grid-item>
      <!--TODO: Fare venire fuori elenco agenti dell'AM da poter pescare (per campo informatore)-->
      <dxi-data-grid-item dataField="informatore"
                [visible]="isAreaManager">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="medici"
                editorType="dxTextArea"
                [visible]="!isLuce">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="microaree"
                editorType="dxTextArea"
                [visible]="!isLuce">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="investmentAuthorizationId"
                [visible]="isAreaManager && !isLuce">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="investmentBudgetTypeId"
                [visible]="isAreaManager && !isLuce">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="fattura"
                [visible]="!isLuce">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="approvazioneAreaManager"
                [visible]="isAreaManager && !isLuce">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="userName"
                [visible]="false">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="foto"></dxi-data-grid-item>
    </dxo-data-grid-form>
  </dxo-data-grid-editing>

  <dxo-data-grid-filter-row [visible]="false"></dxo-data-grid-filter-row>
  <dxo-data-grid-search-panel [visible]="false"></dxo-data-grid-search-panel>
  <dxi-data-grid-column dataField="dataInvestimento"
              caption="Data Investimento"
              dataType="date"
              [hidingPriority]="7"
              [format]="{ type: 'shortDate' }">
    <dxi-data-grid-validation-rule type="required">
    </dxi-data-grid-validation-rule>
    <dxi-data-grid-validation-rule type="range"
                         [min]="minDate"
                         [max]="maxDate"
                         message="La data deve essere compresa tra il mese scorso e l'anno prossimo">
    </dxi-data-grid-validation-rule>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="informatore"
              caption="Informatore"
              [groupIndex]="isAreaManager ? 1 : -1"
              calculateGroupValue="cognomeNomeInformatore"
              groupCellTemplate="informatoreGroupCellTemplate"
              [visible]="isAreaManager">
    @if (isAreaManager) {
    <dxi-data-grid-validation-rule type="required"></dxi-data-grid-validation-rule>
    }
    <dxo-data-grid-lookup [dataSource]="informatoriDS"
                valueExpr="userId"
                displayExpr="nome"
                >
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="investmentTypeId"
              caption="Tipo. Inv.">
    <dxi-data-grid-validation-rule type="required"></dxi-data-grid-validation-rule>
    <dxo-data-grid-lookup [dataSource]="investmentTypesDS"
                valueExpr="investmentTypeId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="note"
              dataType="string"
              caption="Note"
              [hidingPriority]="4">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="medici"
              dataType="string"
              caption="Medici"
              [visible]="!isLuce"
              [hidingPriority]="5">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="microaree"
              dataType="string"
              caption="Micro Aree"
              [visible]="!isLuce"
              [hidingPriority]="3">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="investmentAuthorizationId"
              caption="Autorizzazione"
              [visible]="!isLuce"
              [hidingPriority]="2">
    <dxo-data-grid-lookup [dataSource]="investmentAuthorizationDS"
                valueExpr="investmentAuthorizationId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
    @if (isAreaManager && !isLuce) {
    <dxi-data-grid-validation-rule type="required">
    </dxi-data-grid-validation-rule>
    }
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="importo"
              caption="Importo">
    <dxo-data-grid-format type="fixedPoint" [precision]="2"></dxo-data-grid-format>
    <dxi-data-grid-validation-rule type="required"></dxi-data-grid-validation-rule>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="paymentTypeId"
              caption="Tipo. Pag."
              [hidingPriority]="1">
    @if (isAreaManager) {
    <dxi-data-grid-validation-rule type="required">
    </dxi-data-grid-validation-rule>
    }
    <dxo-data-grid-lookup [dataSource]="paymentTypesDS"
                valueExpr="paymentTypeId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="investmentBudgetTypeId"
              caption="Tipo. Budget"
              [visible]="!isLuce"
              [hidingPriority]="0">
    <dxo-data-grid-lookup [dataSource]="investmentBudgetTypesDS"
                valueExpr="investmentBudgetTypeId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
    @if (isAreaManager) {
    <dxi-data-grid-validation-rule type="required">
    </dxi-data-grid-validation-rule>
    }
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="foto"
              dataType="string"
              [visible]="false"
              [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
              editCellTemplate="editCellTemplate">
  </dxi-data-grid-column>
  <div *dxTemplate="let data of 'cellTemplate'">
    <img [src]="imageURL + data.value" />
  </div>
  <div *dxTemplate="let data of 'editCellTemplate'">
    @if (data.value && !(data.value | checkPdfExtension)) {
    <img #uploadedImage
         class="uploadedImage"
         [src]="imageURL + '/' + data.value" />
    }
    @if (data.value | checkPdfExtension) {
    <iframe class="uploadedImage"
            [src]="getPdfURL(data.value)">
    </iframe>
    }
    <dx-file-uploader #fileUploader
                      [multiple]="false"
                      accept=".pdf,image/*"
                      uploadMode="instantly"
                      [uploadUrl]="backendURL + '/FileUpload/PostInvestments?ngsw-bypass=true'"
                      (onUploaded)="onUploaded($event, data)"
                      (onUploadError)="onUploadError($event)">
    </dx-file-uploader>
    <dx-button class="retryButton" text="Retry" [visible]="retryButtonVisible" (onClick)="onClick($event)"></dx-button>
  </div>

  <dxi-data-grid-column dataField="userName"
              dataType="string"
              [visible]="false"
              [allowEditing]="false">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="approvazioneAreaManager"
              dataType="boolean"
              [groupIndex]="0"
              groupCellTemplate="approvatoGroupCellTemplate"
              sortOrder="asc"
              caption="Approvato">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="fattura"
              dataType="boolean"
              [visible]="false"
              caption="Fattura">
  </dxi-data-grid-column>
  <dxo-data-grid-summary>
    <dxi-data-grid-group-item column="importo"
                    summaryType="sum"
                    [alignByColumn]="true"
                    [showInGroupFooter]="false"
                    [customizeText]="customizeTotaleImporto">
    </dxi-data-grid-group-item>
  </dxo-data-grid-summary>

  <div *dxTemplate="let data of 'approvatoGroupCellTemplate'">
    <div>{{(data.value === true ? 'Approvato' : 'Non Approvato')}}</div>
  </div>

  <div *dxTemplate="let data of 'informatoreGroupCellTemplate'">
    <div>{{data.text}}</div>
  </div>
</dx-data-grid>
<dx-speed-dial-action icon="add"
  label="Aggiungi"
  [index]="1"
  (onClick)="addRow()">
</dx-speed-dial-action>
<dx-speed-dial-action icon="trash"
  label="Cancella"
  [index]="2"
  [visible]="selectedRowIndex !== -1 && modificabile"
  (onClick)="deleteRow()">
</dx-speed-dial-action>
<dx-speed-dial-action icon="edit"
  label="Modifica"
  [index]="3"
  [visible]="selectedRowIndex !== -1 && modificabile"
  (onClick)="editRow()">
</dx-speed-dial-action>
<dx-speed-dial-action icon="todo"
  label="Approva"
  [index]="4"
  [visible]="selectedRowIndex !== -1 && isAreaManager  && modificabile  && completo"
  (onClick)="approvaRow()">
</dx-speed-dial-action>
